// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Finasteride & Dutasteride (WOMEN'S & MEN) 3.31.26 09.17.26" (6fb13b51-981f-4fe0-99b6-fa926b298be9). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiFinasterideDutasterideWomensMENQuestions = [
  {
    field: 'mdiFinasterideDutasterideWomensMEN_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field:
      'mdiFinasterideDutasterideWomensMEN_tryingConceivePlanConceivingNear',
    label:
      'Are you currently trying to conceive or do you plan on conceiving in the near future?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '91c294c6-b0a7-4d83-87e0-b330302cdaab' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_wereSorryButBasedPrevious',
    label:
      "We're sorry, but based on a previous answer, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: 'da346de6-0cdb-491b-92cb-a56be1bc801d',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_experiencingDiffuseThinning',
    label: 'Are you experiencing diffuse thinning?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'd3644a1e-6e05-49ca-af5b-b6961baf00e2' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_primaryConcern',
    label: 'What is your primary concern?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hair_thinning', value: 'Hair thinning' },
        { key: 'receding_hairline', value: 'Receding hairline' },
        { key: 'bald_spots', value: 'Bald spots' },
        { key: 'excess_shedding', value: 'Excess Shedding' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: 'ce56b6a9-9bcd-473b-9202-f01bc85c8c30' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_didFirstNoticeHairLoss',
    label: 'When did you first notice hair loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_6_months_ago', value: 'Less than 6 months ago' },
        { key: 'o_6_12_months_ago', value: '6-12 months ago' },
        { key: 'o_1_3_years_ago', value: '1-3 years ago' },
        { key: 'longer_than_3_years_ago', value: 'Longer than 3 years ago' }
      ]
    },
    extras: { mdiQuestionId: '8c5d45d2-62f8-4977-9901-8dcc9990f848' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_whereHairLossOccurring',
    label: 'Where is the hair loss occurring?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'crown', value: 'Crown' },
        { key: 'temples', value: 'Temples' },
        { key: 'entire_scalp', value: 'Entire scalp' },
        { key: 'patchy_areas', value: 'Patchy Areas' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '77e7707d-555b-4f84-8b1b-20af19fbd411' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_hairLoss',
    label: 'Is your hair loss:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'gradual', value: 'Gradual' },
        { key: 'sudden', value: 'Sudden' },
        { key: 'patchy', value: 'Patchy' }
      ]
    },
    extras: { mdiQuestionId: '7275af0e-cad1-42a7-9488-31078fde8f7c' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_familyHistoryHairloss',
    label: 'Do you have a family history of hairloss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'fa22f921-3b9b-46f9-a3be-b4802cea3a86' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_previouslyUsedTreatments',
    label: 'Have you previously used treatments?',
    type: 'select',
    educationalSlide: '(check all that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'minoxidil', value: 'Minoxidil' },
        { key: 'finasteride', value: 'Finasteride' },
        { key: 'dutasteride', value: 'Dutasteride' },
        { key: 'supplements', value: 'Supplements' },
        { key: 'prp_procedures', value: 'PRP / procedures' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'i_have_not_tried_any_of_the_above_treatm',
          value: 'I have not tried any of the above treatments'
        }
      ]
    },
    extras: { mdiQuestionId: '1702c428-f815-492f-bc24-73a5da1f0a5b' }
  },
  {
    field:
      'mdiFinasterideDutasterideWomensMEN_describePreviousExperiencePriorTreatments',
    label:
      'Can you please describe your previous experience with prior treatments?',
    type: 'info',
    subLabel:
      '(e.g: the specific medication / supplement, any side affects or improvements)',
    answer: {
      type: 'text',
      name: 'mdiFinasterideDutasterideWomensMEN_describePreviousExperiencePriorTreatments',
      rows: 4
    },
    extras: { mdiQuestionId: 'd7b9c449-a30e-4a50-b574-d84f5d1b6600' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_conditions',
    label: 'Do you have any of the following conditions?',
    type: 'select',
    educationalSlide: '(check all that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'liver_disease', value: 'Liver disease' },
        { key: 'hormonal_disorders', value: 'Hormonal disorders' },
        { key: 'prostate_conditions', value: 'Prostate conditions' },
        {
          key: 'history_of_cancer_please_specify',
          value: 'History of cancer (please specify)',
          answer: {
            type: 'text',
            name: 'history_of_cancer_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'depression_or_anxiety', value: 'Depression or anxiety' },
        { key: 'sexual_dysfunction', value: 'Sexual dysfunction' },
        { key: 'erectile_dysfunction', value: 'Erectile dysfunction' },
        { key: 'high_blood_pressure', value: 'High blood pressure' },
        { key: 'heart_disease', value: 'Heart disease' },
        { key: 'kidney_disease', value: 'Kidney Disease' },
        {
          key: 'scalp_conditions_eczema_psoriasis_infect',
          value: 'Scalp conditions (eczema, psoriasis, infections)'
        },
        { key: 'thyroid_disorder', value: 'Thyroid disorder' },
        { key: 'autoimmune_disease', value: 'Autoimmune disease' },
        {
          key: 'anemia_or_nutrient_deficiency',
          value: 'Anemia or nutrient deficiency'
        },
        {
          key: 'skin_conditions_eczema_psoriasis_dermati',
          value: 'Skin conditions (eczema, psoriasis, dermatitis)'
        },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: '3d4c361b-c97d-4e42-9bd5-1e4b1c836fb4' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_conditions2',
    label: 'Do you have any of the following conditions?',
    type: 'select',
    educationalSlide: '(check all that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'liver_disease', value: 'Liver disease' },
        { key: 'hormonal_disorders', value: 'Hormonal disorders' },
        {
          key: 'history_of_cancer_please_specify',
          value: 'History of cancer (please specify)'
        },
        { key: 'depression_or_anxiety', value: 'Depression or anxiety' },
        { key: 'low_libido', value: 'Low Libido' },
        {
          key: 'breast_tenderness_or_enlargement',
          value: 'Breast tenderness or enlargement'
        },
        { key: 'high_blood_pressure', value: 'High blood pressure' },
        { key: 'heart_disease', value: 'Heart disease' },
        { key: 'kidney_disease', value: 'Kidney Disease' },
        {
          key: 'scalp_conditions_eczema_psoriasis_infect',
          value: 'Scalp conditions (eczema, psoriasis, infections)'
        },
        {
          key: 'skin_conditions_eczema_psoriasis_dermati',
          value: 'Skin conditions (eczema, psoriasis, dermatitis)'
        },
        { key: 'thyroid_disorder', value: 'Thyroid disorder' },
        { key: 'autoimmune_disease', value: 'Autoimmune disease' },
        {
          key: 'anemia_or_nutrient_deficiency',
          value: 'Anemia or nutrient deficiency'
        },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'eb0f0906-eaff-4520-9391-2f30ccedbecd' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_underCareChronicIllness',
    label: 'Are you currently under care for any chronic illness?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '16f52498-0695-479a-a753-41e8be1317e7' }
  },
  {
    field:
      'mdiFinasterideDutasterideWomensMEN_provideDoctorFurtherInsightRegarding',
    label:
      'Please provide your doctor with further insight regarding your chronic condition / illness:',
    type: 'info',
    subLabel:
      'Include the duration of time you have had this condition and any relevant treatments.',
    answer: {
      type: 'text',
      name: 'mdiFinasterideDutasterideWomensMEN_provideDoctorFurtherInsightRegarding',
      rows: 4
    },
    extras: { mdiQuestionId: 'b89068cc-059d-41a4-9117-69092b340777' }
  },
  {
    field:
      'mdiFinasterideDutasterideWomensMEN_historyAllergicReactionFinasterideDutasteride',
    label:
      'Do you have any history of allergic reaction to finasteride or dutasteride?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '48623224-58f8-4a4c-ab18-28ef1eab38f3' }
  },
  {
    field:
      'mdiFinasterideDutasterideWomensMEN_explainOccurredDuringReactionMedication',
    label:
      'Can you please explain what occurred during your reaction to the medication?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiFinasterideDutasterideWomensMEN_explainOccurredDuringReactionMedication',
      rows: 4
    },
    extras: { mdiQuestionId: '26e08af5-f77b-4f88-9efd-91b78b04b0fd' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_everToldNotTake5',
    label: 'Have you ever been told NOT to take 5-alpha reductase inhibitors?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '44e72d78-f690-46c0-9794-25ad206d16e4' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_provideDoctorFurtherInsightWhy',
    label:
      'Can you please provide your doctor with further insight as to why you were told to NOT take a 5-alpha reductase inhibitor?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiFinasterideDutasterideWomensMEN_provideDoctorFurtherInsightWhy',
      rows: 4
    },
    extras: { mdiQuestionId: '83fb4a4c-b53d-42e4-b20f-aac5e25b7a4b' }
  },
  {
    field:
      'mdiFinasterideDutasterideWomensMEN_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent  (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiFinasterideDutasterideWomensMEN_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: '21352cab-576b-4484-81db-0cfd0f90acaa' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: {
      type: 'text',
      name: 'mdiFinasterideDutasterideWomensMEN_firstMessageDoctor',
      rows: 4
    },
    extras: { mdiQuestionId: 'e57ce683-c454-4439-ac6a-572bff1a387b' }
  },
  {
    field: 'mdiFinasterideDutasterideWomensMEN_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiFinasterideDutasterideWomensMENAnswerField = Partial<
  QuestionAnswerMap<typeof mdiFinasterideDutasterideWomensMENQuestions>
>;

export default mdiFinasterideDutasterideWomensMENQuestions;
